import React from 'react'

interface ErrorBoundaryProps {
  children: React.ReactNode
}

interface ErrorBoundaryState {
  hasError: boolean
}

export class ErrorBoundary extends React.Component<
  ErrorBoundaryProps,
  ErrorBoundaryState
> {
  constructor(props: ErrorBoundaryProps) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError(error: Error) {
    return { hasError: true }
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error('Erro capturado por ErrorBoundary: ', error, errorInfo)
  }

  render() {
    if (this.state.hasError) {
      console.error('hasError')
      return <div>{this.props.children}</div>
    }

    console.error('Errored router')
    return <div>{this.props.children}</div>
  }
}

export default ErrorBoundary
